const MINUTE_MS = 60000;
const MINUTES_PER_HOUR = 60;
const HOURS_PER_DAY = 24;

/**
 * Coarse "how long ago" label for credential and session lists.
 *
 * Deliberately imprecise: these lists answer "is this recent?", not "exactly
 * when?", and an exact timestamp invites the reader to reason about clock skew
 * between their device and the server.
 */
export const formatLastUsed = (lastUsedAt: string | null): string => {
  if (!lastUsedAt) {
    return 'Never';
  }

  const diffMinutes = Math.floor((Date.now() - new Date(lastUsedAt).getTime()) / MINUTE_MS);

  if (diffMinutes < 1) {
    return 'Just now';
  }
  if (diffMinutes < MINUTES_PER_HOUR) {
    return `${diffMinutes}m ago`;
  }

  const diffHours = Math.floor(diffMinutes / MINUTES_PER_HOUR);
  if (diffHours < HOURS_PER_DAY) {
    return `${diffHours}h ago`;
  }

  return `${Math.floor(diffHours / HOURS_PER_DAY)}d ago`;
};

export default formatLastUsed;
